import React from 'react';
import JobActions from './JobActions';
import styles from './JobCard.module.css';
import { DashboardJob } from './types';

interface JobCardProps {
  job: DashboardJob;
  onClick: () => void;
  onEdit: (e: React.MouseEvent) => void;
  onDelete: (e: React.MouseEvent) => void;
}

const JobCard: React.FC<JobCardProps> = ({ job, onClick, onEdit, onDelete }) => {
  // Calculate days open
  const daysOpen = React.useMemo(() => {
    if (!job.created_at) return 0;
    const created = new Date(job.created_at);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - created.getTime());
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  }, [job.created_at]);

  const isWarning = daysOpen >= 14;
  const hires = job.application_counts?.ACCEPTED || 0;
  const totalPositions = job.expected_hires || 0;
  const fulfillmentPercent = totalPositions > 0 ? Math.min(100, (hires / totalPositions) * 100) : 0;

  return (
    <button className={styles.jobCardButton} onClick={onClick} data-testid="job-card">
      <div className={`${styles.jobCard} ${isWarning ? styles.jobCardWarning : ''}`} data-testid={isWarning ? "job-card-warning" : "job-card-container"}>
        <div className={styles.jobCardHeader}>
          <span className={styles.jobCardTitle} data-testid="job-card-title">{job.title}</span>
          <div className={styles.jobCardHeaderRight}>
            <JobActions jobStatus={job.status} onEdit={onEdit} onDelete={onDelete} />
          </div>
        </div>

        <div className={styles.jobCardStats}>
          <div className={styles.statItem} data-testid="stat-applied">
            <p className={styles.statItemValue}>{job.application_counts?.APPLIED || 0}</p>
            <p className={styles.statItemLabel}>Applied</p>
          </div>
          <div className={styles.statItem} data-testid="stat-consideration">
            <p className={styles.statItemValue}>{job.application_counts?.IN_CONSIDERATION || 0}</p>
            <p className={styles.statItemLabel}>In Consideration</p>
          </div>
          <div className={styles.statItem} data-testid="stat-hired">
            <p className={styles.statItemValue}>
              {job.status === 'OPEN' ? job.application_counts?.ACCEPTED || 0 : hires}
            </p>
            <p className={styles.statItemLabel}>{job.status === 'OPEN' ? 'Accepted' : 'Hired'}</p>
          </div>
        </div>

        <div className={styles.jobCardFulfillment}>
          {job.status === 'OPEN' && (
            <>
              <p className={styles.fulfillmentText} data-testid="fulfillment-text">
                {hires} of {totalPositions} Hires Fulfilled
              </p>
              <div className={styles.fulfillmentBar}>
                <div
                  className={styles.fulfillmentBarProgress}
                  style={{ width: `${fulfillmentPercent}%` }}
                  data-testid="fulfillment-progress"
                ></div>
              </div>
            </>
          )}
        </div>
      </div>
    </button>
  );
};

export default JobCard;
